import { useEffect, type FC } from "react";
import plants from "../../../../assets/images/change-request-confirmation.png";
import { useTypedTranslation } from "../../../hooks";
import * as Styled from "../InflationStepper.styled";
import { InflationResult, InflationStepperProps } from "../InflationStepper.types";

type ProcessingProps = InflationStepperProps & {
    formResult: InflationResult | null;
};

export const Processing: FC<ProcessingProps> = ({ changeInflationProgram, formResult, contractId, setPageIndex }) => {
    const { t } = useTypedTranslation();

    // trigger await changeInflationProgram on mount with formResult
    useEffect(() => {
        if (!formResult) return;
        (async () => {
            try {
                await changeInflationProgram({
                    contractId,
                    setInflationProgramRequest: {
                        inflation: formResult.inflation,
                        gio: formResult.gio,
                    },
                });
                setPageIndex?.(3); // success
            } catch (e) {
                setPageIndex?.(4); // error
            }
        })();
    }, []);

    return (
        <>
            <Styled.ImageWrapper>
                <Styled.MuiImage src={plants} alt={"processing"} />
            </Styled.ImageWrapper>

            <Styled.BodyText>{t("inflationStepper.processing.requestInProgress")}</Styled.BodyText>

            <Styled.Spacer />

            <Styled.ContinueButtonWrapper>
                <Styled.ContinueButton>
                    <Styled.Progress size={30} />
                </Styled.ContinueButton>
            </Styled.ContinueButtonWrapper>
        </>
    );
};
